import { render } from "./UpdateClass.vue?vue&type=template&id=66a8f47e&scoped=true"
import script from "./UpdateClass.vue?vue&type=script&lang=js"
export * from "./UpdateClass.vue?vue&type=script&lang=js"

import "./UpdateClass.vue?vue&type=style&index=0&id=66a8f47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a8f47e"]])

export default __exports__